import React, { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Trash2, FolderKanban } from "lucide-react";
import { PageHeader, EmptyState } from "../components/Brand";
import { useApp, API } from "../AppContext";

export default function Projects() {
  const { t, lang } = useApp();
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({ name: "", address: "", client_id: "", status: "active" });
  const [open, setOpen] = useState(false);

  const load = () => {
    axios.get(`${API}/projects`).then(({ data }) => setProjects(data));
    axios.get(`${API}/clients`).then(({ data }) => setClients(data));
  };
  useEffect(load, []);

  const save = async () => {
    if (!form.name) return;
    await axios.post(`${API}/projects`, form);
    setForm({ name: "", address: "", client_id: "", status: "active" });
    setOpen(false);
    load();
  };

  const remove = async (id) => { await axios.delete(`${API}/projects/${id}`); load(); };

  return (
    <div>
      <PageHeader title={t.projects_p.title}
        action={<button className="btn-red" onClick={() => setOpen(true)} data-testid="new-project-btn"><Plus size={16} /> {t.projects_p.new}</button>} />

      {open && (
        <div className="glass-strong p-6 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input className="input-dark" placeholder={t.projects_p.name + " *"} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="project-form-name" />
            <select className="input-dark" value={form.client_id} onChange={(e) => setForm({ ...form, client_id: e.target.value })}>
              <option value="">— {lang === "fr" ? "Aucun client" : "No client"} —</option>
              {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            <input className="input-dark md:col-span-2" placeholder={t.projects_p.address} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button className="btn-ghost text-sm" onClick={() => setOpen(false)}>{lang === "fr" ? "Annuler" : "Cancel"}</button>
            <button className="btn-red text-sm" onClick={save} data-testid="project-save">{t.projects_p.save}</button>
          </div>
        </div>
      )}

      {projects.length === 0 ? (
        <EmptyState title={t.projects_p.empty} icon={<FolderKanban size={24} color="#D4AF37" />} />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p) => (
            <div key={p.id} className="glass-card p-5 group">
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-heading text-base font-semibold" style={{ color: "#F5F5F5" }}>{p.name}</h3>
                <button onClick={() => remove(p.id)} className="opacity-0 group-hover:opacity-100 transition p-1.5 rounded-full hover:bg-red-500/10">
                  <Trash2 size={14} color="#C00000" />
                </button>
              </div>
              <p className="text-xs" style={{ color: "rgba(245,245,245,0.55)" }}>{p.address}</p>
              <span className="badge badge-approved mt-3 inline-flex">{p.status}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
